<template>
  <div id="app" @click="refresh">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
export default {
  name: "app",
  data() {
    return {
      time: "",
      timerCount: "",
    };
  },
  created() {
    this.refresh();
  },
  updated() {},
  methods: {
    async refresh() {
      // 4 hours
      // if (localStorage.getItem("idToken")) {
      //   await Auth.currentAuthenticatedUser();
      //   this.getSession();
      // }
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.cerrar();
      }, 7200000);
    },
    cerrar() {
      sessionStorage.clear();
      localStorage.clear();
      this.$router.replace({ name: "Login" }).catch((err) => {});
    },
    // getSession() {
    //   Auth.currentSession()
    //     .then((data) => {
    //       localStorage.setItem("idToken", data["idToken"]["jwtToken"]);
    //     })
    //     .catch((err) => {
    //       // console.log(err);
    //     });
    // },
  },
};
</script>
<style>
html,
body {
  height: 100%;
  font-size: small;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.principal {
  margin-top: 70px;
}
.wrapper {
  flex: 1 0 auto;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
}

.label-success-status {
  background-color: #c8e6c9;
  color: #256029;
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: small;
  letter-spacing: 0.3px;
}
.label-success-info {
  background-color: #b3e5fc;
  color: #23547b;
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: small;
  letter-spacing: 0.3px;
}
.label-success-warning {
  background-color: #feedaf;
  color: #8a5340;
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: small;
  letter-spacing: 0.3px;
}

.margin-rigth {
  margin-right: 2px;
}
.avatar-red {
  background-color: #fa411c !important;
}
.avatar-green {
  background-color: #689f38 !important;
}
.icon-white {
  color: white !important;
}
.operations-delivery {
  background-color: #ededed;
  margin-left: 46px;
}
.operations-import {
  background-color: #ededed;
  margin-left: 46px;
}
.operations-post-venta {
  background-color: #ededed;
  margin-left: 46px;
}
.operations-accounting {
  background-color: #ededed;
  margin-left: 46px;
}
.operations-delivery-columns-header {
  background-color: #70ad47 !important;
  width: 170px !important;
  text-align: center !important;
}
.operations-delivery-columns-body {
  background-color: #e2efda !important;
  width: 170px !important;
  text-align: center !important;
}
.operations-delivery-columns-direction-header {
  background-color: #70ad47 !important;
  width: 295px !important;
  text-align: center !important;
}
.operations-delivery-columns-direction-body {
  background-color: #e2efda !important;
  width: 295px !important;
  text-align: center !important;
}
.operations-operation-destination-columns-header {
  background-color: #70ad47 !important;
  width: 100px !important;
  text-align: center !important;
}
.operations-operation-destination-columns-body {
  background-color: #e2efda !important;
  width: 100px !important;
  text-align: center !important;
}
.operations-import-columns-header {
  background-color: #70ad47 !important;
  width: 150px !important;
  text-align: center !important;
}
.operations-import-columns-body {
  background-color: #e2efda !important;
  width: 150px !important;
  text-align: center !important;
}
.operations-import-columns-status-header {
  background-color: #70ad47 !important;
  width: 90px !important;
  text-align: center !important;
}
.operations-import-columns-status-body {
  background-color: #e2efda !important;
  width: 90px !important;
  text-align: center !important;
}
.operations-post-venta-columns-header {
  background-color: #ffc000 !important;
  width: 175px !important;
  text-align: center !important;
}
.operations-post-venta-columns-body {
  background-color: #fff2cc !important;
  width: 175px !important;
  text-align: center !important;
}
.operations-accounting-columns-header {
  background-color: #00d9ff !important;
  width: 175px !important;
  text-align: center !important;
}
.operations-accounting-columns-body {
  background-color: #ccf5ff !important;
  width: 175px !important;
  text-align: center !important;
}
.operations-post-venta-operation-document-number-columns-header {
  background-color: #ffc000 !important;
  width: 115px !important;
  text-align: center !important;
}
.operations-post-venta-operation-document-number-columns-body {
  background-color: #fff2cc !important;
  width: 115px !important;
  text-align: center !important;
}
.operations-post-venta-status-columns-header {
  background-color: #ffc000 !important;
  width: 130px !important;
  text-align: center !important;
}
.operations-accounting-operation-document-number-columns-header {
  background-color: #00d9ff !important;
  width: 115px !important;
  text-align: center !important;
}
.operations-accounting-operation-document-number-columns-body {
  background-color: #ccf5ff !important;
  width: 115px !important;
  text-align: center !important;
}
.operations-accounting-operation-document-number-columns-body {
  background-color: #ccf5ff !important;
  width: 115px !important;
  text-align: center !important;
}
.operations-accounting-operation-profit-columns-header {
  background-color: #00d9ff !important;
  width: 110px !important;
  text-align: center !important;
}
.operations-accounting-operation-profit-columns-body {
  background-color: #ccf5ff !important;
  width: 110px !important;
  text-align: center !important;
}
.operations-accounting-status-columns-header {
  background-color: #00d9ff !important;
  width: 130px !important;
  text-align: center !important;
}
.operations-accounting-status-columns-body {
  background-color: #ccf5ff !important;
  width: 130px !important;
  text-align: center !important;
}
.operations-post-venta-status-columns-body {
  background-color: #fff2cc !important;
  width: 130px !important;
  text-align: center !important;
}
.user-edit-datatable-profile-body {
  padding-bottom: 100px !important;
  width: 175px;
  text-align: center !important;
}
.user-datatable-profile-body {
  width: 175px;
  text-align: center !important;
}
button.p-row-editor-init {
  border-radius: 50% !important;
  height: 2.357rem !important;
  color: #ffffff !important;
  background: #2196f3 !important;
  border: 1px solid #2196f3 !important;
  width: 2.357rem !important;
  padding: 0.5rem 0 !important;
}
.p-calendar .p-datepicker {
  min-width: 350px !important;
  z-index: 3333 !important;
  top: 35px !important;
}
.input-number-full-width {
  width: 100%;
}
.tag_margin_left {
  margin-left: 5px;
}
.navbar-toggler-bar {
  background: white !important;
}
.navbar-collapse:before {
  background: #2196f3 !important;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#2196f3),
    color-stop(80%, #000)
  ) !important;
  background: linear-gradient(#2196f3 0%, #000 80%) !important;
}
</style>